import React from 'react';
import EmptyState from '../empty-state/empty-state';
import * as s from './styled-table-empty';

const TableEmpty = ({ titulo, subtitulo, icon }) => (
  <s.Container>
    <EmptyState
      icon={icon && <img src={icon} alt="" />}
      title={titulo}
      description={subtitulo}
    />
  </s.Container>
);

export default TableEmpty;
